<template>
<div>
  <div class="uk-text-left" uk-grid>
        <div class="uk-width-expand">
             <h5>Answers:</h5>
        </div>
        <div class="uk-width-auto uk-text-right">
          <ul class="uk-iconnav uk-text-light">
            <span v-if="message" class="uk-text-small uk-margin-large-right uk-text-center uk-text-light" :class="message.type">{{message.text}}</span>
            <li><a href="#" uk-icon="icon: plus" uk-tooltip="Create answer" @click.prevent="createAnswer()"></a></li>
          </ul>
        </div>
  </div>
  <ul class="uk-list">
    <li v-for="(item, index) in list" v-bind:key="item.id">
        <item-answer v-bind:parent-id="parentId" v-bind:number="index + 1" v-bind:answer="item" v-bind:type="type" @delete:answer="deleteAnswer($event)" @update:answer="updateAnswer($event)"/>
    </li>
  </ul>
</div>
</template>

<script>
import AnswerService from '@/services/answer.service';
import ItemAnswer from '@/components/ItemAnswer.vue';
import Answer from '@/models/answer';
export default {
    name: 'ListAnswers',
    props: {
        parentId: String,
        type: String,
        answers: Array
    },
    components: {
      'item-answer': ItemAnswer
    },
    data() {
      return {
        answer: new Answer('', '', null),
        message: ''
      }
    },
    computed :{
      list() {
        return this.answers;
      }
    },
    created() {
      setInterval(() => {
        this.message = null;
      }, 10000)
    },
    methods: {
    createAnswer() {
      let answer = new Answer('', '', null);
      AnswerService.create({parentId: this.parentId, answer: answer}).then(
        res => {

            this.list.push(res.data.answer);
            this.message = {text: res.data.message, type: 'uk-text-success'}
        },
        error => {
            let message = (error.response && error.response.data.message.message) || error.message || error.toString();
            this.message = {text: message, type: 'uk-text-danger'}
        }
      )
    },
    deleteAnswer(id) {
      AnswerService.delete({parentId: this.parentId, id: id}).then(
        res => {
            
            this.list.splice(this.list.indexOf(function(el){
                return el._id === id;
            }), 1);
            this.message = {text: res.data.message, type: 'uk-text-success'}
        },
        error => {
            let message = (error.response && error.response.data.message.message) || error.message || error.toString();
            this.message = {text: message, type: 'uk-text-danger'}
        }
      )
    },
    updateAnswer(answer){
      this.list.splice(this.list.indexOf(function(el){
                return el._id === answer._id;
      }), 1, answer);
    }

  },
}
</script>

<style>
.number{
    position: relative;
    display: block;
    right: 20px;
    top: 33px;
    width: 10px;
 }
</style>